import React from 'react'
import { mount } from 'enzyme'
import business from './testData/business'
import InterimControls from '../InterimControls'

describe('<InterimControls />', () => {
  it('should render without crashing', () => {
    mount(
      <InterimControls
        resourceType="Business"
        entity={business}
        year={2018}
        isEditable
        onAdd={() => {}}
        onRemove={() => {}}
      />
    )
  })
  it('renders nothing if its "resourceType" prop is something other than "Business"', () => {
    const wrapper = mount(
      <InterimControls
        resourceType="ResourceType"
        entity={business}
        year={2018}
        isEditable
        onAdd={() => { }}
        onRemove={() => { }}
      />
    )
    expect(wrapper.find('div').exists()).toBeFalsy()
  })
  it('renders nothing if its "entity" prop\'s "borrowerType" property is not "oc"', () => {
    const businessCopy = JSON.parse(JSON.stringify(business))
    businessCopy.borrowerType = 'EPC'
    const wrapper = mount(
      <InterimControls
        resourceType="ResourceType"
        entity={business}
        year={2018}
        isEditable
        onAdd={() => { }}
        onRemove={() => { }}
      />
    )
    expect(wrapper.find('div').exists()).toBeFalsy()
  })
  it('renders nothing if its "isEditable" props is false', () => {
    const wrapper = mount(
      <InterimControls
        resourceType="ResourceType"
        entity={business}
        year={2018}
        isEditable
        onAdd={() => { }}
        onRemove={() => { }}
      />
    )
    expect(wrapper.find('div').exists()).toBeFalsy()
  })
  // FIXME: this test description is incorrect and the logic need to be cleaned up
  it('should render an "Add Interim" link if its year prop is equal to the last year and there are no interim years', () => {
    const businessCopy = JSON.parse(JSON.stringify(business))
    businessCopy.interimYears = []
    businessCopy.applicableYears.pop()
    businessCopy.fiscalYears = businessCopy.fiscalYears.filter(fy => fy.period === 'interim')
    const wrapper = mount(
      <InterimControls
        resourceType="Business"
        entity={businessCopy}
        year={2017}
        isEditable
        onAdd={() => { }}
        onRemove={() => { }}
      />
    )
    expect(wrapper.find('a').first().text()).toEqual('Add Interim')
    expect(wrapper.find('a').last().text()).toEqual('Remove Interim')
    expect(wrapper.find('a').length).toEqual(2)
  })
  // FIXME: this test description is incorrect and the logic need to be cleaned up
  it('should render "Add Interim" and "Remove Interim" links if its year prop equals the only interim year and it is editable', () => {
    const wrapper = mount(
      <InterimControls
        resourceType="Business"
        entity={business}
        year={2018}
        isEditable
        onAdd={() => {}}
        onRemove={() => {}}
      />
    )
    expect(wrapper.find('a').first().text()).toEqual('Add Interim')
    expect(wrapper.find('a').last().text()).toEqual('Remove Interim')
  })
  it('should render a "Remove Interim" link if its year prop equals the last interim year, it is editable, and there are two interim years', () => {
    const businessCopy = JSON.parse(JSON.stringify(business))
    businessCopy.interimYears = [2017, 2018]
    businessCopy.fiscalYears.find(fy => fy.year === 2017).period = 'interim'
    const wrapper = mount(
      <InterimControls
        resourceType="Business"
        entity={businessCopy}
        year={2018}
        isEditable
        onAdd={() => { }}
        onRemove={() => { }}
      />
    )
    expect(wrapper.find('a').length).toEqual(1)
    expect(wrapper.find('a').first().text()).toEqual('Remove Interim')
  })
  it('should call its "onAdd" prop when "Add Interim" is clicked', () => {
    const mockOnAdd = jest.fn()
    const wrapper = mount(
      <InterimControls
        resourceType="Business"
        entity={business}
        year={2018}
        isEditable
        onAdd={mockOnAdd}
        onRemove={() => {}}
      />
    )
    wrapper.find('a').first().simulate('click')
    expect(mockOnAdd.mock.calls.length).toEqual(1)
  })
  it('should call its "onRemove" prop when "Remove Interim" is clicked', () => {
    const mockOnRemove = jest.fn()
    const wrapper = mount(
      <InterimControls
        resourceType="Business"
        entity={business}
        year={2018}
        isEditable
        onAdd={() => {}}
        onRemove={mockOnRemove}
      />
    )
    wrapper.find('a').last().simulate('click')
    expect(mockOnRemove.mock.calls.length).toEqual(1)
  })
})
